import QuestionsFooter from "components/auth/QuestionsFooter";
import SidePanel from "components/auth/SidePanel";
import SignUpPasswordForm from "components/auth/SignUpPasswordForm";
import Helment from "components/layout/helmet";
import React from "react";
import { TestIdScope } from "utils/testid";

const SignUpPassword = () => {
  return (
    <>
      <Helment />
      <TestIdScope scope="auth-sign-up-password">
        <div
          data-testid="auth-sign-up-password-page"
          className="lg:overflow-y-none overflow-y-auto portal-shell h-[var(--shell-vh)] flex lg:justify-center relative animate__animated animate__fadeIn lg:flex-row flex-col"
        >
          <div className="lg:w-2/5 w-full">
            <SidePanel />
          </div>
          <div className="lg:w-3/5 w-full h-full flex flex-col items-center justify-between lg:overflow-y-auto">
            <div>
              <div className="lg:pt-10 pt-5 px-5 max-w-[520px] w-full ">
                <div
                  className="flex bg-btnBackGround px-[10px] py-3 gap-[10px]"
                  role="status"
                  data-testid="auth-sign-up-password-existing-account-notice"
                >
                  <InfoCircle aria-hidden="true" />
                  <p className="lg:text-base text-blue text-sm">
                    Your email is already associated with an existing account.
                  </p>
                </div>
              </div>
              <div className="lg:pt-[48px] p-5 w-full flex justify-center">
                <SignUpPasswordForm />
              </div>
            </div>
            <div className={`pb-5 lg:pt-0 pt-4`}>
              <QuestionsFooter />
            </div>
          </div>
        </div>
      </TestIdScope>
    </>
  );
};

const InfoCircle = (props: any) => (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.0007 20.1673C16.0423 20.1673 20.1673 16.0423 20.1673 11.0007C20.1673 5.95898 16.0423 1.83398 11.0007 1.83398C5.95898 1.83398 1.83398 5.95898 1.83398 11.0007C1.83398 16.0423 5.95898 20.1673 11.0007 20.1673Z"
      stroke="var(--color-btn-primary-active)"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 7.33398V11.9173"
      stroke="var(--color-btn-primary-active)"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.9941 14.666H11.0024"
      stroke="var(--color-btn-primary-active)"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SignUpPassword;
